import ApiService from '../../utils/fetch';
const inboundShipmentUrl = `${process.env.REACT_APP_BASE_URL}supply/shipments/`;

export const fetchHeaderAndLinesData = async (shipmentNo) => {
    const response = await ApiService.get(`${inboundShipmentUrl}${shipmentNo}`);
    return response.data;
};

export const fetchDeliveryData = async (shipmentNo) => {
    const response = await ApiService.get(`${inboundShipmentUrl}${shipmentNo}/delivery`);
    return response.data;
}

export const fetchItemsData = async (shipmentNo) => {
    const response = await ApiService.get(`${inboundShipmentUrl}${shipmentNo}/item`);
    return response.data;
}

export const fetchOrdersData = async (shipmentNo, orderType) => {
    const response = await ApiService.get(`${inboundShipmentUrl}${shipmentNo}/order?orderType=${orderType}`);
    return response.data;
}

